
import { getGlobalStorage } from './storage';
import Cipher, { opaqueDecrypt } from './cipher';
import Gzip from './gzip';

export function encryptFormData(data, key='') {

    let NCC_SYS_Switch = JSON.parse(localStorage.getItem('NCC_SYS_Switch')) || {};
    let cipherFlag = NCC_SYS_Switch.aesKey;
    let gzip = NCC_SYS_Switch.gzip;

    //压缩开关
    //let gzip = getGlobalStorage('localStorage', 'gzip');
    let gziptools = new Gzip();

    let gData = data;

    //加密开关
    //let cipherFlag = getGlobalStorage('localStorage', 'rockin');
    Cipher.CipherFlag = cipherFlag;

    //加密密钥
    let aeskey = opaqueDecrypt((key || getGlobalStorage('localStorage', 'cowboy')));

    if (gzip) {
        if (typeof gData !== 'string') {
            gData = JSON.stringify(gData);
        }
        gData = gziptools.zip(gData);
    }
    return Cipher.encrypt(gData, aeskey);
}

export function decryptFormData(data, crux='') {
    let NCC_SYS_Switch = JSON.parse(localStorage.getItem('NCC_SYS_Switch')) || {};
    let cipherFlag = NCC_SYS_Switch.aesKey;
    let gzip = NCC_SYS_Switch.gzip;
    //加密开关
    let gziptools = new Gzip();
    //加密密钥
    let aeskey = opaqueDecrypt(getGlobalStorage('localStorage', 'cowboy'));
    if(crux){
        crux = String(crux);
        aeskey = crux + aeskey.substring(0, aeskey.length - crux.length);
    }

    Cipher.CipherFlag = cipherFlag;

    data = (typeof data === 'string') ? Cipher.decrypt(data, aeskey) : data;
    if (gzip) {
        return gziptools.unzip(data);
    } else {
        return typeof data == 'string' ? JSON.parse(data) : data;
    }
}